import styled from 'styled-components';
import { styleVariables } from '../../../common/constants';

const CompanyRootElement = styled.div`
    width: 100%;
    background: #f2f2f2;
    .page-container {
        padding-top: ${styleVariables.primitivesSpacings['8']};
        padding-bottom: ${styleVariables.primitivesSpacings['8']};
    }
    @media (max-width: 767px) {
        padding-top: ${styleVariables.primitivesSpacings['6']};
        padding-bottom: ${styleVariables.primitivesSpacings['6']};
    }
    &.company-information{
        background: #F9F9F9; 
    }
    .accordion-list {
        box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1) inset;
        margin: 0 0 4px 0px;
        &.Mui-expanded {
            box-shadow:
                0px 0px 0px 1px rgba(204, 204, 204, 0.5) inset,
                0px -1px 0px 0px #666 inset;
            margin: 0 0 4px 0px;
        }
    }
    .accordion-heading {
        padding: 0;
        .MuiAccordionSummary-content {
            padding: 16px;
            justify-content: space-between;
            .MuiTypography-headline-smaller{
                padding-right:5px;
            }
            svg {
                transform: rotate(0deg);
            }
            &.Mui-expanded {
                svg {
                    transform: rotate(180deg);
                }
            }
        }
    }
    .accordion-content {
        padding: 0 16px 30px;
        ul {
            list-style-position: outside;
            line-height: 24px;
            padding-left: 30px;
        }
        p {
            color: ${styleVariables.primitivesColor.primary.black};
            a {
                color: ${styleVariables.primitivesColor.primary.black} !important;
            }
        }
    }
    .sub-description {
        max-width: 812px;
    }
    .content-row {
        display: flex;
        gap: 30px;
        border-bottom: #808080 solid 1px;
        padding-bottom: 24px;
        padding-top: 24px;
        @media (max-width: 767px) {
            flex-direction: column;
            align-items: flex-start;
            gap: initial;
        }
        }
        .first-col {
            flex: 1 1 33%;
            padding-right: 45px;
            box-sizing: border-box;
            @media (max-width: 767px) {
                flex: 1 1 100%;
                padding-right: 0;
                margin-bottom:18px;
            }
        }
        .second-col {
            flex: 1 1 52%;
            @media (max-width: 767px) {
                flex: 1 1 100%;
                margin-bottom:30px;
            }
        }
        .third-col {
            flex: 1 1 15%;
            text-align: center;
            @media (max-width: 767px) {
                width: 112px;
            }
            img {
                width: 120px;
                display: inline-block;
            }
        }
    }
    .skeleton-shimmer {
        transform: none;
        margin-bottom: 4px;
    }
    .see-more-button {
        margin-top: 12px;
        display: flex;
        align-items: center;
        cursor: pointer;
        svg {
            margin-left: 9px;
        }
    }
`;
export default CompanyRootElement;
